<template>
    <div>
        <v-row>
            <v-col>
                <h4 class="text-h4">Sales By Item Details Report</h4>
                <p class="text-body-1">Item sales details</p>
                <v-divider></v-divider>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <DatePicker 
                    v-model="form.date_from"
                    :label="$t('date_from')"
                    outlined
                    dense
                />
            </v-col>
            <v-col>
                <DatePicker 
                    v-model="form.date_to"
                    :label="$t('date_to')"
                    outlined
                    dense
                />
            </v-col>
            <v-col>
                <v-autocomplete
                    outlined
                    dense
                    :label="$t('branch')"
                    :items="branches"
                    :loading="branchesLoading"
                    @update:search-input="searchBranches"
                    :rules="rules.branch_id"
                    item-text="name"
                    item-value="id"
                    v-model="form.branch_id"
                    hide-details="auto"
                    clearable
                />
            </v-col>
            <v-col>
                <v-btn color="primary" block @click="submit">
                    <v-icon left>mdi-magnify</v-icon>
                    search
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <CastingReportDataTable
                    ref="castingReportDataTable"
                    :date-from="form.date_from"
                    :date-to="form.date_to"
                    :branch_id="form.branch_id"
                    />
            </v-col>
        </v-row>
    </div>    
</template>

<script>
import branch from './../../services/sales/branch';
import DatePicker from "./../../components/common/DatePicker.vue"
import CastingReportDataTable from '../../components/Sales/CastingReportDataTable';
import moment from 'moment';


export default {
    name: "CastingReportPage",
    components: {
        CastingReportDataTable,
        DatePicker
    },
    data() {
        return {
            menu: {
                date_from: null,
                date_to: null
            },
            form: {
                date_from: null,
                date_to: null,
                branch_id: null
            },
            rules: {
                date_from: [

                ],
                date_to: [
                    
                ]
            },
            branchesLoading: false,
            branches: [
                { id: null, name: "All"}
            ]
        }
    },
    computed: {

    },
    methods: {
        submit() {
            this.$refs.castingReportDataTable.submit()
        },
        searchBranches(query) {
            this.branchesLoading = true;
            branch.search(query).then(res => {
                this.branches = [...this.branches, ...res.data];
            }).finally(() => {
                this.branchesLoading = false;
            })
        }
    },
    mounted() {
        this.form.date_from = moment().subtract(1, 'days').format("YYYY-MM-DD");
        this.form.date_to = moment().format("YYYY-MM-DD");
    }
}
</script>